import {
  createEfItem,
  listAllEfItems,
  softDeleteEfItem,
  updateEfItem,
  type EfItemFields,
} from '@/shared/api/controllers/efItems';
import { SimpleAbmEntity, type SimpleAbmAdapter } from '../../SimpleAbmEntity';
import type { EntityViewProps } from '../../types';

const adapter: SimpleAbmAdapter<EfItemFields> = {
  queryKey: ['configuracion', 'ef-items'],
  abmKind: 'ef-items',
  listAll: listAllEfItems,
  create: createEfItem,
  update: updateEfItem,
  softDelete: softDeleteEfItem,
  valueOf: (i) => i.fields.Nombre ?? '',
  statusOf: (i) => i.fields.Status,
  fieldLabel: 'EF Item',
  fieldPlaceholder: 'Ingresar EF Item',
  entitySingular: 'EF Item',
  createdMessage: 'EF Item creado correctamente.',
  updatedMessage: 'EF Item actualizado correctamente.',
  deletedMessage: 'EF Item eliminado correctamente.',
};

export function EfItemsEntity(props: EntityViewProps) {
  return <SimpleAbmEntity adapter={adapter} {...props} />;
}
